(function() {
  var QUOTE_FORM_ID = "1149304";
  var DEBUG = /[?&]relaydebug=1/.test(window.location.search);
  function log() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    console.log.apply(console, ["[relay]"].concat(args));
    try {
      var line = (/* @__PURE__ */ new Date()).toISOString().slice(11, 19) + " " + args.map(function(a) {
        return typeof a === "string" ? a : JSON.stringify(a);
      }).join(" ");
      localStorage.setItem("relayLog", ((localStorage.getItem("relayLog") || "") + line + "\n").slice(-2e4));
    } catch (e) {
    }
  }
  if (DEBUG && window.fetch) {
    window.__relay = { note: "submit the form, then read this object again" };
    var nativeFetch = window.fetch;
    window.fetch = function(input) {
      var url = typeof input === "string" ? input : input && input.url || "";
      var res = nativeFetch.apply(this, arguments);
      if (url.indexOf("forms.shopifyapps.com") !== -1 && url.indexOf("submission") !== -1) {
        res.then(function(r) {
          r.clone().text().then(function(body) {
            window.__relay = { status: r.status, url, body: body.slice(0, 2e3) };
            log("APP RESPONDED", r.status, body.slice(0, 600));
          });
        }, function(err) {
          window.__relay = { status: "network error", url, body: String(err) };
          log("APP POST FAILED", String(err));
        });
      }
      return res;
    };
  }
  function leadsRoots(formId) {
    return document.querySelectorAll(
      '.quote-modal__leads[data-leads-form-id="' + formId + '"]'
    );
  }
  function leadsHost(formId) {
    var roots = leadsRoots(formId);
    for (var i = 0; i < roots.length; i++) {
      var h = roots[i].querySelector("shopify-forms-embed, shopify-forms-embed-dev");
      if (h) return h;
    }
    return null;
  }
  function rootsUnder(start) {
    var roots = start ? [start] : [];
    for (var i = 0; i < roots.length; i++) {
      Array.prototype.forEach.call(roots[i].querySelectorAll("*"), function(node) {
        if (node.shadowRoot && roots.indexOf(node.shadowRoot) === -1) {
          roots.push(node.shadowRoot);
        }
      });
    }
    return roots;
  }
  function leadsForm(formId) {
    var host = leadsHost(formId);
    if (host && host.shadowRoot) {
      var shadowRoots = rootsUnder(host.shadowRoot);
      for (var j = 0; j < shadowRoots.length; j++) {
        var inShadow = shadowRoots[j].querySelector("form");
        if (inShadow) return inShadow;
      }
    }
    var roots = leadsRoots(formId);
    for (var i = 0; i < roots.length; i++) {
      var f = roots[i].querySelector("form");
      if (f) return f;
    }
    return null;
  }
  function whenLeadsForm(formId, cb) {
    var tries = 0;
    (function poll() {
      var lf = leadsForm(formId);
      if (lf || tries >= 80) {
        log("form", formId, lf ? "found after " + tries * 100 + "ms" : "NEVER MOUNTED");
        cb(lf);
        return;
      }
      tries++;
      setTimeout(poll, 100);
    })();
  }
  function setValue(el, val) {
    if (el.type === "checkbox" || el.type === "radio") {
      var want = el.type === "checkbox" ? !!val : squash(el.value) === squash(val) || squash(hayOf(el)).indexOf(squash(val)) !== -1;
      if (want !== el.checked) el.click();
      ["input", "change"].forEach(function(type) {
        el.dispatchEvent(new Event(type, { bubbles: true }));
      });
      return;
    }
    if (el.tagName === "SELECT") {
      var want = squash(val);
      var hit = Array.prototype.filter.call(el.options, function(o) {
        return squash(o.value) === want || squash(o.textContent) === want;
      })[0];
      if (!hit) {
        hit = Array.prototype.filter.call(el.options, function(o) {
          return o.value && (squash(o.textContent).indexOf(want) !== -1 || want.indexOf(squash(o.textContent)) !== -1);
        })[0];
      }
      if (!hit) return;
      el.value = hit.value;
      ["input", "change", "blur"].forEach(function(type) {
        el.dispatchEvent(new Event(type, { bubbles: true }));
      });
      return;
    }
    var proto = el.tagName === "TEXTAREA" ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    var desc = Object.getOwnPropertyDescriptor(proto, "value");
    if (desc && desc.set) {
      desc.set.call(el, val);
    } else {
      el.value = val;
    }
    ["input", "change", "blur"].forEach(function(type) {
      el.dispatchEvent(new Event(type, { bubbles: true }));
    });
  }
  function hayOf(el) {
    var label = el.labels && el.labels[0] ? el.labels[0].textContent : "";
    return [
      el.name,
      el.id,
      el.type,
      el.placeholder,
      el.autocomplete,
      el.getAttribute("aria-label") || "",
      label
    ].join(" ");
  }
  function squash(text) {
    return String(text).toLowerCase().replace(/[^a-z0-9]/g, "");
  }
  function choiceGroups(lf) {
    var groups = {};
    Array.prototype.forEach.call(lf.querySelectorAll('input[type="radio"], input[type="checkbox"]'), function(r) {
      if (r.type !== "radio" && r.type !== "checkbox") return;
      var key = r.type + ":" + (r.name || r.id);
      (groups[key] = groups[key] || []).push(r);
    });
    return Object.keys(groups).map(function(k) {
      return groups[k];
    }).filter(function(g) {
      return g[0].type === "radio" || g.length > 1;
    });
  }
  function groupQuestion(radios) {
    var box = radios[0].closest ? radios[0].closest('fieldset, [role="radiogroup"], [role="group"]') : null;
    if (box) {
      var named = box.getAttribute("aria-labelledby");
      var root = box.getRootNode ? box.getRootNode() : document;
      var head = named && root.getElementById ? root.getElementById(named) : null;
      var legend = box.querySelector("legend");
      return (head ? head.textContent : "") + " " + (legend ? legend.textContent : "") + " " + (box.getAttribute("aria-label") || "");
    }
    var parent = radios[0].parentElement;
    while (parent && parent.contains && radios.some(function(r) {
      return !parent.contains(r);
    })) parent = parent.parentElement;
    return parent ? parent.textContent || "" : "";
  }
  function pickRadio(radios, val) {
    var want = squash(val);
    var opt = function(r) {
      return squash((r.labels && r.labels[0] ? r.labels[0].textContent : "") || r.value);
    };
    var hit = radios.filter(function(r) {
      return opt(r) === want || squash(r.value) === want;
    })[0] || radios.filter(function(r) {
      var o = opt(r);
      return o && (want.indexOf(o) !== -1 || o.indexOf(want) !== -1);
    })[0];
    if (!hit) return false;
    if (!hit.checked) hit.click();
    ["input", "change"].forEach(function(type) {
      hit.dispatchEvent(new Event(type, { bubbles: true }));
    });
    return { exact: opt(hit) === want || squash(hit.value) === want };
  }
  function fillLeads(lf, data) {
    var fields = Array.prototype.filter.call(
      lf.querySelectorAll("input, textarea, select"),
      function(el) {
        return el.type !== "hidden" && el.type !== "submit" && el.type !== "checkbox" && el.type !== "radio";
      }
    );
    var groups = choiceGroups(lf);
    var inGroup = function(el) {
      return groups.some(function(g) {
        return g.indexOf(el) !== -1;
      });
    };
    var requiredChecks = Array.prototype.filter.call(
      lf.querySelectorAll('input[type="checkbox"]'),
      function(el) {
        return (el.required || el.getAttribute("aria-required") === "true") && !inGroup(el);
      }
    );
    function take(match) {
      for (var i = 0; i < fields.length; i++) {
        if (match(hayOf(fields[i]))) return fields.splice(i, 1)[0];
      }
      return null;
    }
    function byPattern(re) {
      return take(function(hay) {
        return re.test(hay);
      });
    }
    function byLabel(label) {
      var want = squash(label);
      if (!want) return null;
      return take(function(hay) {
        return squash(hay).indexOf(want) !== -1;
      });
    }
    [
      [/email/i, data.email],
      [/phone|tel|mobile|number/i, data.phone],
      [/name/i, data.name]
    ].forEach(function(pair) {
      var el = byPattern(pair[0]);
      if (el) setValue(el, pair[1]);
    });
    var message = byPattern(/message|comment|body|note|enquir|inquir/i);
    var spare = [];
    (data.extra || []).forEach(function(pair) {
      var el = byLabel(pair[0]);
      if (el) {
        setValue(el, pair[1]);
        log("matched", pair[0], "=", pair[1]);
        return;
      }
      var want = squash(pair[0]);
      for (var i = 0; want && i < groups.length; i++) {
        var picked = squash(groupQuestion(groups[i])).indexOf(want) !== -1 && pickRadio(groups[i], pair[1]);
        if (picked) {
          groups.splice(i, 1);
          if (!picked.exact) spare.push(pair[0] + ": " + pair[1]);
          log("matched choice", pair[0], "=", pair[1]);
          return;
        }
      }
      spare.push(pair[0] + ": " + pair[1]);
      log("NO FIELD", pair[0], "=", pair[1]);
    });
    if (message) {
      setValue(message, data.extra ? spare.join(String.fromCharCode(10)) : data.body);
    }
    requiredChecks.forEach(function(el) {
      setValue(el, true);
    });
    if (DEBUG) {
      log("after fill:", Array.prototype.map.call(
        lf.querySelectorAll("input, textarea, select"),
        function(el) {
          return (hayOf(el).trim().split(/\s+/)[0] || el.type) + "=" + JSON.stringify(el.type === "checkbox" ? el.checked : el.value);
        }
      ).join("  "));
    }
  }
  function submitLeads(formId, data, onDone, onFail) {
    whenLeadsForm(formId, function(lf) {
      if (!lf) {
        onFail();
        return;
      }
      fillLeads(lf, data);
      var settled = false;
      function settle(fn) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        observers.forEach(function(obs) {
          obs.disconnect();
        });
        fn();
      }
      var observers = [];
      function observe(root) {
        if (!root) return;
        var obs = new MutationObserver(function() {
          if (!leadsForm(formId)) {
            log("STORED — the app removed its form");
            settle(onDone);
          }
        });
        obs.observe(root, { childList: true, subtree: true });
        observers.push(obs);
      }
      var host = leadsHost(formId);
      if (host && host.shadowRoot) {
        rootsUnder(host.shadowRoot).forEach(observe);
      } else {
        observe(lf.ownerDocument.body);
      }
      var WAIT_MS = 2e4;
      var timer = setTimeout(giveUp, WAIT_MS);
      function giveUp() {
        var host2 = leadsHost(formId);
        var root2 = host2 && host2.shadowRoot;
        var errs = root2 ? Array.prototype.map.call(
          root2.querySelectorAll('[role="alert"], [class*="rror"], [aria-invalid="true"]'),
          function(e) {
            return (e.getAttribute("name") || e.id || "") + " " + (e.textContent || "").trim();
          }
        ).filter(Boolean) : [];
        log(
          "TIMED OUT — the app never took its form off the page.",
          "| errors on form:",
          errs.join(" // ") || "none",
          "| captcha present:",
          !!(root2 && root2.querySelector('iframe[src*="captcha"], .h-captcha')) || !!document.querySelector('iframe[src*="hcaptcha"], .h-captcha')
        );
        settle(onFail);
      }
      var go = lf.querySelector('button[type="submit"]') || lf.querySelector('input[type="submit"]') || lf.querySelector("button");
      if (DEBUG) {
        var invalid = Array.prototype.map.call(
          lf.querySelectorAll(":invalid"),
          function(e) {
            return e.name || e.id || e.tagName;
          }
        );
        log(
          "native validity:",
          lf.checkValidity ? lf.checkValidity() : "n/a",
          "| invalid:",
          invalid.join(", ") || "none"
        );
      }
      log("submitting via", go ? "button: " + (go.textContent || "").trim() : "requestSubmit");
      if (go) {
        go.click();
      } else if (lf.requestSubmit) {
        lf.requestSubmit();
      } else {
        log("NO SUBMIT CONTROL FOUND");
        settle(onFail);
      }
    });
  }
  function wire(form) {
    if (form.dataset.quoteRelay) return;
    form.dataset.quoteRelay = "1";
    var card = form.closest(".cat-cta__form-card") || form.parentNode;
    var formView = card.querySelector("[data-quote-form-view]");
    var successView = card.querySelector("[data-quote-success]");
    var errorEl = form.querySelector("[data-quote-error]");
    function val(field) {
      var el = form.querySelector('[name="contact[' + field + ']"]');
      return el ? el.value : "";
    }
    form.addEventListener("submit", function(e) {
      e.preventDefault();
      var nv = val("name");
      var pv = val("phone");
      var ev = val("email");
      var body = [
        "Name: " + nv,
        "Phone: +91 " + pv,
        "Email: " + ev,
        "Source: " + ((form.querySelector("[data-quote-source]") || {}).value || "Quote Form")
      ].join(String.fromCharCode(10));
      var bodyField = form.querySelector('[name="contact[body]"]');
      if (bodyField) bodyField.value = body;
      var btn = form.querySelector(".cat-cta__submit");
      var lbl = btn.querySelector(".quote-modal__btn-label") || btn.querySelector("span") || btn;
      var orig = lbl.textContent;
      btn.disabled = true;
      lbl.textContent = "Sending…";
      if (errorEl) errorEl.hidden = true;
      function done() {
        if (formView && successView) {
          formView.hidden = true;
          successView.hidden = false;
        } else {
          btn.disabled = false;
          lbl.textContent = orig;
          form.reset();
        }
      }
      function contactFallback() {
        fetch(form.action.split("#")[0], {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams(new FormData(form)).toString(),
          redirect: "manual"
        }).then(done).catch(function() {
          btn.disabled = false;
          lbl.textContent = orig;
          if (errorEl) errorEl.hidden = false;
        });
      }
      submitLeads(
        QUOTE_FORM_ID,
        { name: nv, phone: pv ? "+91 " + pv : "", email: ev, body },
        done,
        contactFallback
      );
    });
  }
  function init() {
    document.querySelectorAll("form.cat-cta__form").forEach(wire);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
